export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const SET_TOKEN_USER = 'SET_TOKEN_USER';
export const SET_FIN_YEAR = 'SET_FIN_YEAR';
export const SET_COMPANY = 'SET_COMPANY';
export const SET_CUSTOMER = 'SET_CUSTOMER';
export const SET_USER = 'SET_USER';
export const SET_SUPER_USER = 'SET_SUPER_USER';